module.exports = __webpack_public_path__ + "img/HongKongTrustSwper4.f241408e.png";